import { Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src="/logo.webp" 
                alt="TesisKirala" 
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-slate-400 max-w-md mb-6">
              Türkiye&apos;nin en kolay tesis kiralama platformu. Halı saha, kapalı spor salonu ve daha fazlasını kolayca bulun ve rezerve edin.
            </p>
            
            {/* Payment Methods */}
            <div>
              <p className="text-sm text-slate-500 mb-3 flex items-center gap-2">
                <CreditCard className="w-4 h-4" />
                Güvenli Ödeme Yöntemleri
              </p>
              <div className="flex items-center gap-3">
                {/* Visa */}
                <div className="bg-white rounded-md px-2 py-1">
                  <svg viewBox="0 0 48 48" className="h-6 w-auto">
                    <path fill="#1565C0" d="M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z"/>
                    <path fill="#FFF" d="M15.186 19l-2.626 7.832c0 0-.667-3.313-.733-3.729-1.495-3.411-3.701-3.221-3.701-3.221L10.726 30v-.002h3.161L18.258 19H15.186zM17.689 30L20.56 30 22.296 19 19.389 19zM38.008 19h-3.021l-4.71 11h2.852l.588-1.571h3.596L37.619 30h2.613L38.008 19zM34.513 26.328l1.563-4.157.818 4.157H34.513zM26.369 22.206c0-.606.498-1.057 1.926-1.057.928 0 1.991.674 1.991.674l.466-2.309c0 0-1.358-.515-2.691-.515-3.019 0-4.576 1.444-4.576 3.272 0 3.306 3.979 2.853 3.979 4.551 0 .291-.231.964-1.888.964-1.662 0-2.759-.609-2.759-.609l-.495 2.216c0 0 1.063.606 3.117.606 2.059 0 4.915-1.54 4.915-3.752C30.354 23.586 26.369 23.394 26.369 22.206z"/>
                    <path fill="#FFC107" d="M12.212,24.945l-0.966-4.748c0,0-0.437-1.029-1.573-1.029c-1.136,0-4.44,0-4.44,0S10.894,20.84,12.212,24.945z"/>
                  </svg>
                </div>
                {/* Mastercard */}
                <div className="bg-white rounded-md px-2 py-1">
                  <svg viewBox="0 0 48 48" className="h-6 w-auto">
                    <path fill="#3F51B5" d="M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z"/>
                    <path fill="#FFC107" d="M30 14A10 10 0 1 0 30 34A10 10 0 1 0 30 14Z"/>
                    <path fill="#FF3D00" d="M18 14A10 10 0 1 0 18 34A10 10 0 1 0 18 14Z"/>
                    <path fill="#FF9800" d="M18,24c0,3.271,1.578,6.175,4.012,8C24.422,30.175,26,27.271,26,24s-1.578-6.175-4.012-8C19.578,17.825,18,20.729,18,24z"/>
                  </svg>
                </div>
                {/* PayTR */}
                <div className="bg-white rounded-md px-3 py-1">
                  <span className="text-sm font-bold text-blue-600">PayTR</span>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/tesisler" className="text-slate-400 hover:text-white transition-colors">
                  Tesisler
                </Link>
              </li>
              <li>
                <Link to="/giris" className="text-slate-400 hover:text-white transition-colors">
                  Giriş Yap
                </Link>
              </li>
              <li>
                <Link to="/sss" className="text-slate-400 hover:text-white transition-colors">
                  Sıkça Sorulan Sorular
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Yasal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/kvkk" className="text-slate-400 hover:text-white transition-colors">
                  KVKK Aydınlatma Metni
                </Link>
              </li>
              <li>
                <Link to="/gizlilik-politikasi" className="text-slate-400 hover:text-white transition-colors">
                  Gizlilik Politikası
                </Link>
              </li>
              <li>
                <Link to="/kullanim-kosullari" className="text-slate-400 hover:text-white transition-colors">
                  Kullanım Koşulları
                </Link>
              </li>
              <li>
                <Link to="/cerez-politikasi" className="text-slate-400 hover:text-white transition-colors">
                  Çerez Politikası
                </Link>
              </li>
              <li>
                <Link to="/mesafeli-satis-sozlesmesi" className="text-slate-400 hover:text-white transition-colors">
                  Mesafeli Satış Sözleşmesi
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">İletişim</h4>
            <ul className="space-y-2 text-slate-400">
              <li>
                <a href="mailto:tesiskirala@gmail.com" className="hover:text-white transition-colors">
                  tesiskirala@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+905053686091" className="hover:text-white transition-colors">
                  +90 505 368 60 91
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-500">
          <p>&copy; {new Date().getFullYear()} tesiskirala.com - Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
